'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagJmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.95639e-05 2C2.95639e-05 0.895435 0.89546 4.05509e-06 2.00003 4.05509e-06H26C27.1046 4.05509e-06 28 0.895435 28 2V18C28 19.1046 27.1046 20 26 20H2.00003C0.895461 20 2.95639e-05 19.1046 2.95639e-05 18V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.95639e-05 4.05509e-06H28V20H2.95639e-05V4.05509e-06Z",
          fill: "#1DBE4F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.95639e-05 4.05509e-06L12 10L2.95639e-05 20V4.05509e-06Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 4.05509e-06L16 10L28 20V4.05509e-06Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 8.39171L1.58534 -0.000854492L2.95639e-05 4.05509e-06L-0.00390625 2.15234L11.6156 10L-0.00142872 17.7925L2.95639e-05 20L1.61168 20.006L14 11.6083L26.5134 20.0042L28 20L28.0044 17.839L16.3844 10L27.9982 2.16274L28 4.05509e-06L26.4268 0.00369138L14 8.39171Z",
          fill: "#FFD646"
        }
      )
    ]
  }
);
const VpFlagJmAsset = forwardRef(FlagJmAsset);

export { VpFlagJmAsset as default };
